<template>
  <v-card>
    <div class="d-flex justify-content-between align-items-center mt-3 p-3">
      <div class="title">
        <h1>Penilaian Jasmani</h1>
      </div>
      <div class="toolbar mb-2">
        <ButtonComponent colors="#3751E4" name="tambah" title="Tambah" v-b-modal.modal-penilaian-jasmani
          @click.native="openModal('Tambah')" style="z-index: 2;"></ButtonComponent>
      </div>
    </div>
    <div class="d-flex justify-content-center mt-3">
      <div class="card" style="
          border-radius: 10px;
          box-shadow: 2px 1px 4px rgba(0, 0, 0, 0.25);
          box-sizing: border-box;
          width: 922px;
          height: 41px;
          text-align: left;
        ">
        <div style="margin-top: auto; margin-bottom: auto; margin-left: 20px; padding: 10px;">
          Daftar mahasiswa yang terdapat pada table di bawah berdasarkan tahun sekarang dan prodi yang di pilih
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center mt-3">
      <div class="card" style="
          border-left: 63px solid #3751E4;
          box-shadow: 2px 1px 4px rgba(0, 0, 0, 0.25);
          border-radius: 5px;
          width: 228px;
          height: 54px;
        ">
        <div class="row" style="margin-left: -60px;">
          <div class="col-md-3" style="margin-top: auto; margin-bottom: auto;">
            <img :src="img_A" style="width: 36px; height: 41.5px;" />
          </div>
          <div class="col-md-4" style="margin-top: auto; margin-bottom: auto;">
            <span style="font-weight: 600; font-size: 20px;">A</span><br>
            <span style="font-weight: 300; font-size: 15px;">Lari</span>
          </div>
        </div>
      </div>

      <div class="card ml-20" style="
          border-left: 63px solid #3751E4;
          box-shadow: 2px 1px 4px rgba(0, 0, 0, 0.25);
          border-radius: 5px;
          width: 228px;
          height: 54px;
        ">
        <div class="row" style="margin-left: -60px;">
          <div class="col-md-3" style="margin-top: auto; margin-bottom: auto;">
            <img :src="img_B1" style="width: 49.5px; height: 42px; margin-left: -7px;" />
          </div>
          <div class="col-md-4" style="margin-top: auto; margin-bottom: auto;">
            <span style="font-weight: 600; font-size: 20px;">B1</span><br>
            <span style="font-weight: 300; font-size: 15px;">Pull Up</span>
          </div>
        </div>
      </div>

      <div class="card ml-20" style="
          border-left: 63px solid #3751E4;
          box-shadow: 2px 1px 4px rgba(0, 0, 0, 0.25);
          border-radius: 5px;
          width: 228px;
          height: 54px;
        ">
        <div class="row" style="margin-left: -60px;">
          <div class="col-md-3" style="margin-top: auto; margin-bottom: auto;">
            <img :src="img_B2" style="width: 40.5px; height: 38px; margin-left: -4px;" />
          </div>
          <div class="col-md-4" style="margin-top: auto; margin-bottom: auto;">
            <span style="font-weight: 600; font-size: 20px;">B2</span><br>
            <span style="font-weight: 300; font-size: 15px;">Sit Up</span>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center mt-3">
      <div class="card" style="
          border-left: 63px solid #3751E4;
          box-shadow: 2px 1px 4px rgba(0, 0, 0, 0.25);
          border-radius: 5px;
          width: 228px;
          height: 54px;
        ">
        <div class="row" style="margin-left: -60px;">
          <div class="col-md-3" style="margin-top: auto; margin-bottom: auto;">
            <img :src="img_B3" style="width: 40.5px; height: 39.5px; margin-left: -3px;" />
          </div>
          <div class="col-md-5" style="margin-top: auto; margin-bottom: auto;">
            <span style="font-weight: 600; font-size: 20px;">B3</span><br>
            <span style="font-weight: 300; font-size: 15px;">Push Up</span>
          </div>
        </div>
      </div>

      <div class="card ml-20" style="
          border-left: 63px solid #3751E4;
          box-shadow: 2px 1px 4px rgba(0, 0, 0, 0.25);
          border-radius: 5px;
          width: 228px;
          height: 54px;
        ">
        <div class="row" style="margin-left: -60px;">
          <div class="col-md-3" style="margin-top: auto; margin-bottom: auto;">
            <img :src="img_B4" style="width: 41.5px; height: 41px; margin-left: -3px;" />
          </div>
          <div class="col-md-6" style="margin-top: auto; margin-bottom: auto;">
            <span style="font-weight: 600; font-size: 20px;">B4</span><br>
            <span style="font-weight: 300; font-size: 15px;">Shuttle Run</span>
          </div>
        </div>
      </div>

      <div class="card ml-20" style="
          border-left: 63px solid #3751E4;
          box-shadow: 2px 1px 4px rgba(0, 0, 0, 0.25);
          border-radius: 5px;
          width: 228px;
          height: 54px;
        ">
        <div class="row" style="margin-left: -60px;">
          <div class="col-md-3" style="margin-top: auto; margin-bottom: auto;">
            <img :src="img_B5" style="width: 41.5px; height: 38.5px; margin-left: -3px;" />
          </div>
          <div class="col-md-5" style="margin-top: auto; margin-bottom: auto;">
            <span style="font-weight: 600; font-size: 20px;">B5</span><br>
            <span style="font-weight: 300; font-size: 15px;">Renang</span>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-5">
      <b-form>
        <b-form-group label="Pilih Prodi :">
          <Select2 v-model="myValue" :options="prodiOptions"
            :settings="{ settingOption: value, multiple: false, width: '50%' }" @change="myChangeEvent($event)"
            @select="mySelectEvent($event)" />
        </b-form-group>
      </b-form>
    </div>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field v-model="PenilaianJasmani.search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table :headers="PenilaianJasmani.headers" :items="PenilaianJasmani.isi_data"
      :search="PenilaianJasmani.search">
      <template v-slot:item.action="{ item }">
        <ButtonComponent colors="#3751E4" name="edit" title="Edit" v-b-modal.modal-penilaian-jasmani
          @click.native="openModal('Edit')"></ButtonComponent>
        <ButtonComponent colors="#EF4848" name="hapus" title="Hapus"></ButtonComponent>
      </template>
    </v-data-table>

    <b-modal id="modal-penilaian-jasmani" size="lg" :title="`${statusModal} Penilaian Jasmani`" ok-title="Simpan"
      ok-variant="primary" cancel-title="Batal" cancel-variant="danger">
      <b-form>
        <div class="row">
          <div class="col-lg-6">
            <b-form-group label="NRP">
              <b-form-input id="nrp" type="text" required placeholder="Masukkan NRP"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <b-form-group label="Nama">
              <b-form-input id="nama" type="text" required placeholder="Masukkan nama"></b-form-input>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6">
            <b-form-group label="Umur (Tahun)">
              <b-form-input id="umur" type="text" required placeholder="Masukkan umur"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <b-form-group label="Jenis Kelamin">
              <b-form-input id="jenis_kelamin" type="text" required placeholder="Masukkan jenis kelamin"></b-form-input>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6">
            <b-form-group label="Tinggi Badan (TB)">
              <b-form-input id="tinggi" type="text" required placeholder="Masukkan tinggi badan"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <b-form-group label="Berat Badan (BB)">
              <b-form-input id="berat" type="text" required placeholder="Masukkan berat badan"></b-form-input>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6">
            <b-form-group label="A (meter)">
              <b-form-input id="nilai_A" type="text" required placeholder="Masukkan nilai A"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <b-form-group label="B1 (jumlah)">
              <b-form-input id="nilai_B1" type="text" required placeholder="Masukkan nilai B1"></b-form-input>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6">
            <b-form-group label="B2 (jumlah)">
              <b-form-input id="nilai_B2" type="text" required placeholder="Masukkan nilai B2"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <b-form-group label="B3 (jumlah)">
              <b-form-input id="nilai_B3" type="text" required placeholder="Masukkan nilai B3"></b-form-input>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6">
            <b-form-group label="B4 (jumlah)">
              <b-form-input id="nilai_B4" type="text" required placeholder="Masukkan nilai B4"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <b-form-group label="B5 (jumlah)">
              <b-form-input id="nilai_B5" type="text" required placeholder="Masukkan nilai B5"></b-form-input>
            </b-form-group>
          </div>
        </div>
      </b-form>
    </b-modal>
  </v-card>
</template>

<script>
import Select2 from 'v-select2-component';
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue";

export default {
  data() {
    return {
      myValue: '',
      prodiOptions: [
        { id: 'a', text: 'Tes 1' },
        { id: 'b', text: 'Tes 2' }
      ],
      PenilaianJasmani: {
        search: "",
        headers: [
          { text: "No", align: "center", value: "no", sortable: false },
          { text: "NRP", align: "center", value: "nrp" },
          { text: "Nama", align: "center", value: "nama" },
          { text: "Umur (Tahun)", align: "center", value: "umur" },
          { text: "Jenis Kelamin", align: "center", value: "jenis_kelamin" },
          { text: "TB", align: "center", value: "tb" },
          { text: "BB", align: "center", value: "bb" },
          { text: "A (Meter)", align: "center", value: "a" },
          { text: "B1 (Jumlah)", align: "center", value: "b1" },
          { text: "B2 (Jumlah)", align: "center", value: "b2" },
          { text: "B3 (Jumlah)", align: "center", value: "b3" },
          { text: "B4 (Jumlah)", align: "center", value: "b4" },
          { text: "B5 (Jumlah)", align: "center", value: "b5" },
          { text: "Aksi", align: "center", value: "action", sortable: false }
        ],
        isi_data: [
          {
            no: 1,
            nrp: 18120,
            nama: "Abdul Gofur S.H.MASS",
            umur: 23,
            jenis_kelamin: "Pria",
            tb: 180,
            bb: 65,
            a: "165 m",
            b1: 200,
            b2: 0,
            b3: 199,
            b4: 0,
            b5: 0,
            action: ''
          }
        ]
      },
      statusModal: ''
    };
  },
  components: {
    Select2,
    ButtonComponent
  },
  computed: {
    img_A() {
      return process.env.BASE_URL + "media/assets/rund.png";
    },
    img_B1() {
      return process.env.BASE_URL + "media/assets/pull_up.png";
    },
    img_B2() {
      return process.env.BASE_URL + "media/assets/sit_up.png";
    },
    img_B3() {
      return process.env.BASE_URL + "media/assets/push_up.png";
    },
    img_B4() {
      return process.env.BASE_URL + "media/assets/shuttle_run.png";
    },
    img_B5() {
      return process.env.BASE_URL + "media/assets/renang.png";
    }
  },
  methods: {
    openModal(status) {
      this.statusModal = status;
    }
  }
}
</script>